export function getPaginationRange(
  totalItems: number,
  pageSize: number,
  currentPage: number,
  siblingCount = 1
): (number | string)[] {
  const totalPageCount = Math.ceil(totalItems / pageSize);

  // show all if few pages
  if (totalPageCount <= 5) {
    return Array.from({ length: totalPageCount }, (_, i) => i + 1);
  }

  const firstPage = 1;
  const lastPage = totalPageCount;

  if (currentPage <= 2) {
    return [1, 2, 3, "...", lastPage];
  }

  if (currentPage >= totalPageCount - 1) {
    return [firstPage, "...", totalPageCount - 2, totalPageCount - 1, lastPage];
  }

  return [firstPage, "...", currentPage, "...", lastPage];
}
